const COOKIES_ERROR = 'Your browser has cookies disabled. Make sure your cookies are enabled';
const COOKIES_REGEXP = /^.+_token$|^dc203.+$/;
function setCookie(name, value, config = {}) {
    const options = {
        domain: getCookiesDomain(),
        path: '/',
        ...config
    };
    if (options.expires instanceof Date) options.expires = options.expires.toUTCString();
    document.cookie = Object.entries(options).reduce((cookie, [key, option])=>true !== option ? `${cookie}; ${key}=${option}` : `${cookie}; ${key}`, `${encodeURIComponent(name)}=${encodeURIComponent(value)}`);
}
function getCookie(name) {
    if (!checkCookiesEnabled()) return;
    const regExp = new RegExp(`(?:^|; )(${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}.*?)=([^;]*)`);
    const matches = document.cookie.match(regExp);
    return matches && void 0 !== matches[2] ? decodeURIComponent(matches[2]) : void 0;
}
function deleteCookie(name) {
    setCookie(name, '', {
        'max-age': -1
    });
}
function getCookiesDomain() {
    return window.location.hostname.split('.').slice(-2).join('.');
}
function checkCookiesEnabled() {
    let cookiesEnabled = navigator.cookieEnabled;
    if (!cookiesEnabled) {
        document.cookie = 'test_cookie';
        cookiesEnabled = -1 !== document.cookie.indexOf('test_cookie');
        deleteCookie('test_cookie');
    }
    return cookiesEnabled;
}
function clearCookies(regExp = COOKIES_REGEXP) {
    for (const cookie of document.cookie.split(';')){
        const eqPos = cookie.indexOf('=');
        const name = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
        if (regExp.test(name)) deleteCookie(name);
    }
}
export { COOKIES_ERROR, COOKIES_REGEXP, checkCookiesEnabled, clearCookies, deleteCookie, getCookie, getCookiesDomain, setCookie };
